import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { FC, useEffect, useState } from "react";
import Loader from "@/shared/ui/Loader";
import { QueryKey } from "@/domains/transportWarehouse/constants/queryKey";
import { Tab } from "@/domains/transportWarehouse/constants/tab";
import { useTransportWarehouseStore } from "@/domains/transportWarehouse/store";
import { fetchTransportWarehouseGetInfo } from "@/domains/transportWarehouse/helpers/fetchTransportWarehouseGetInfo";
import TransportWarehouseInfoContainer from "@/domains/transportWarehouse/containers/TransportWarehouseInfoContainer";
import TransportWarehouseTabsContainer from "@/domains/transportWarehouse/containers/TransportWarehouseTabsContainer";
import TransportWarehouseTransportContainer from "@/domains/transportWarehouse/containers/TransportWarehouseTransportContainer";
import TransportWarehouseWrapper from "@/domains/transportWarehouse/components/TransportWarehouseWrapper";

const tabComponent: Record<
  Tab,
  FC<{
    isFirstRender?: boolean;
  }>
> = {
  [Tab.Info]: TransportWarehouseInfoContainer,
  [Tab.Transport]: TransportWarehouseTransportContainer,
};

export default function TransportWarehouseContainer() {
  const [isFirstRender, setIsFirstRender] = useState(true);
  const currTab = useTransportWarehouseStore((state) => state.currTab);
  const Component = tabComponent[currTab];

  useEffect(() => setIsFirstRender(false), []);

  const { data, isLoading } = useQuery({
    queryKey: [QueryKey.TransportWarehouseInfo],
    queryFn: fetchTransportWarehouseGetInfo,
    placeholderData: keepPreviousData,
    staleTime: 30 * 1000,
    gcTime: 5 * 60 * 1000,
    refetchOnMount: true,
  });

  return (
    <TransportWarehouseWrapper>
      {isLoading && <Loader />}
      {!isLoading && !data && "транспортного склада нет"}
      {!isLoading && data && (
        <>
          <TransportWarehouseTabsContainer />
          <Component isFirstRender={isFirstRender} />
        </>
      )}
    </TransportWarehouseWrapper>
  );
}
